/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const PACKER_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "OrgProfile"],
];

export const PACKER_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "UsersList"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "DashboardVerifierAnalysis"],
  ["read", "CarnivalCatagory"],
  ["read", "MasqueraderDashboardOverview"],
  ["read", "MasqueraderList"],
  ["read", "PackingDashboardOverview"],
  ["read", "PackerAdminList"],
  ["read", "PackerList"],
  ["read", "SchedulingDashboardOverview"],
  ["read", "ScheduleList"],
  ["read", "ScheduleTable"],
  ["read", "DistributionCenter"],
  ["read", "DistributionCenterDetails"],
  ["read", "ShelfList"],
  ["read", "ShelfDetail"],
  ["read", "BoxList"],
  ["read", "BoxDetail"],
  ["read", "RowDetail"],
  ["read", "UsersImport"],
  ["read", "UtilityCenter"],
  ["read", "UtilityCenterDetails"],
  ["read", "TokenIssuanceDashboardOverview"],
  ["read", "TokenIssuerList"],
  ["read", "AccountingDashboardOverview"],
  ["read", "CashierList"],
  ["read", "PickerList"],
  ["read", "PickingDashboardOverview"],
  ["read", "DistributionDashboardOverview"],
  ["read", "DistributorList"],
];
